import React from 'react';
import { CircularProgress as CProgress } from "@mui/material";

interface ICircularProgressProps {
    className?: string;
    size?: number;
}

export const CircularProgress: React.FC<ICircularProgressProps> = ({
                                                                            className,
                                                                            size = 30
                                                                        }) => (
    <div className={className}>
        <CProgress color="secondary" size={size}/>
    </div>
);
